export const environment = {
    production: false,
    defaultauth: 'fackbackend',
    firebaseConfig: {
        apiKey: '',
        authDomain: '',
        databaseURL: '',
        projectId: '',
        storageBucket: '',
        messagingSenderId: '',
        appId: '',
        measurementId: ''
    },
    API_ITURRIAPP: 'https://api.iturriapp.com/public/rest/',
    API_URI: '//testing.iturriapp.com/api/rest/',
    PUBLIC_URI: '//testing.iturriapp.com/m/rest/',
    CDN_BASE: '//testing.iturriapp.com/',
    CDN_CLOUDINARY: '',
    PARAM: {
        ACTIVO: '1',
        INACTIVO: '0',
        SI: '1',
        NO: '0',
        TODOS: '-1',
        VACIO: ''
    },
    HTTP_RESPONSE: {
        SUCCESS: 1,
        WARNING: 2,
        ERROR: 3,
        INFO: 4,
        PERMISION_ERROR: 401,
        CODE_NOT_DEFINED: 601,
        MALFORMED_JSON: 701,
        ACCESS_DENIED: 403
    },
    VISTA_LISTA: {
        CAMPACTO: 1,
        TABLA: 2,
    },
    MODULO_OPERADOR_VIEW: '2',
    FILTRO_REPORTE: {
        FECHA: "1",
        SEMANA: "2"
    },
    TIPO_SERVICIO: {
        PRELIMINAR: "1",
        FINAL: "2",
        CORRECCION: "3",
        VGM: "4",
        VGM_PRELIMINAR: "5"
    },
    URL_LOGIN: '//testing.iturriapp.com',
};
